import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {PledgeZipcodeReport} from '../../../../../services/api.client';
import {BehaviorSubject, Observable} from 'rxjs';
import {formatDecimal} from '../../../../../utilities/Util';
import {PledgeReportForm} from '../../PledgeReportForm';

@Component({
    templateUrl: './PledgeByZipCodeReportComponent.html',
    standalone: false
})
export class PledgeByZipCodeReportComponent implements OnInit {

    @ViewChild('form')
    form: PledgeReportForm;

    private readonly _pledgeDemographicByZipCodeReport$ = new BehaviorSubject<PledgeZipcodeReport[]>(null);

    pledgeDemographicByZipCodeReport$: Observable<PledgeZipcodeReport[]> = this._pledgeDemographicByZipCodeReport$.asObservable();

    tableHeaders: ITableHeader[] = [
        {text: 'Zip Code'},
        {text: 'Pledge Count'},
        {text: 'Pledge Amount'},
    ];

    rows: Observable<(string | number)[][]>;

    ngOnInit(): void {
        this.rows = this.pledgeDemographicByZipCodeReport$.pipe(
            filter(pledges => !!pledges),
            map((pledges) =>
                pledges.map(pledge => [
                    pledge.zipcode,
                    pledge.pledgeCount,
                    '$' + formatDecimal(pledge.pledgeTotal)
                ])), );
    }

    submitReport(): void {
        this.form.submitPledgeDemographicByZipcodeReport()
            ?.subscribe({next: (report) => this._pledgeDemographicByZipCodeReport$.next(report), error: () => {}});
    }
}
